export const METRICS_TABLE_QUERY_KEYS = {
  attribute: 'attribute.contains',
  value: 'value.contains',
  organizationName: 'organizationName.contains',
  serialNo: 'serialNo.contains',
  neighbourhoodName: 'neighbourhoodName.contains',
  deviceReportedTimeStart: 'deviceReportedTime.greaterThanOrEqual',
  deviceReportedTimeEnd: 'deviceReportedTime.lessThanOrEqual',
};
